import { useEffect } from "react";
import { Form } from "react-bootstrap";
import { useLocalities } from "../../hooks/use-locations";

export const NO_NEIGHBORHOOD = "No aplica";

interface Props {
  provinceId: string | null;
  /** Municipio elegido: la lista se limita a sus corregimientos. */
  cityId?: string | null;
  /** IdLocalidad de Inter; vacío = "No aplica" (el envío va a la ciudad). */
  code?: string;
  onChange: (neighborhood: { name: string; code: string }) => void;
}

/**
 * Barrio / Corregimiento: corregimientos y veredas con cobertura de
 * Interrapidísimo del departamento elegido. Opcional; por defecto "No aplica".
 * Se guarda el nombre (para mostrar) y el IdLocalidad (para cotizar y despachar).
 */
export const NeighborhoodSelect = ({ provinceId, cityId, code, onChange }: Props) => {
  const { localities, isLoading, isError } = useLocalities(provinceId, cityId);

  // Al cambiar de municipio, un corregimiento de otro deja de ser válido.
  useEffect(() => {
    if (!isLoading && !isError && code && !localities.some((l) => l.id === code)) {
      onChange({ name: NO_NEIGHBORHOOD, code: "" });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoading, isError, code, localities]);

  return (
    <Form.Select
      style={{ height: "50px" }}
      value={code || ""}
      onChange={(e) => {
        const locality = localities.find((l) => l.id === e.target.value);
        onChange(
          locality
            ? { name: locality.name, code: locality.id }
            : { name: NO_NEIGHBORHOOD, code: "" }
        );
      }}
      disabled={!provinceId || !cityId || isLoading}
    >
      <option value="">
        {isLoading
          ? "Cargando localidades..."
          : isError
            ? "No se pudieron cargar (No aplica)"
            : NO_NEIGHBORHOOD}
      </option>
      {localities.map((l) => (
        <option key={l.id} value={l.id}>
          {l.name}
        </option>
      ))}
    </Form.Select>
  );
};
